import GTM from 'services/AirBaltic/GTM'
import Vue from 'vue'

class Voucher {
  static push (data) {
    GTM.doDataLayerPush(data)
  }

  static clickOnVoucherLink () {
    this.push({
      event: 'GAevent',
      eventCategory: 'Frontpage',
      eventAction: 'Flight Search Form',
      eventLabel: 'C:voucher; A:open; Lang: ' + Vue.i18n.locale(),
      nonInteraction: 0
    })
  }

  static voucherAdded (voucherCode) {
    this.push({
      event: 'GAevent',
      eventCategory: 'Frontpage',
      eventAction: 'Flight Search Form',
      eventLabel: 'C:voucher; A:applied; Code: ' + voucherCode + '; Lang: ' + Vue.i18n.locale(),
      nonInteraction: 0
    })
  }

}

export default Voucher
